import Content from '../components/layout/Content';
import GiftCardTemplatesEditor from './gift-card-templates/GiftCardTemplatesEditor';

const GiftCardTemplates = () => {
    return (
        <Content>
            <div className='container mx-auto py-10'>
                <div className='mb-6'>
                    <h1 className='text-3xl font-bold'>Gutscheinkarten-Vorlagen</h1>
                    <p className='text-muted-foreground'>
                        Verwalten Sie Gutscheinkarten-Vorlagen. Gutscheinkarten können an Kunden verkauft und als Zahlungsmittel verwendet werden.
                    </p>
                </div>

                <GiftCardTemplatesEditor />
            </div>
        </Content>
    );
};

export default GiftCardTemplates;
